import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './AprovarClientesEdit.css';
import Sidebar from '../../components/Sidebar/Sidebar';
import Topbar from '../../components/Topbar/Topbar';
import { API_URL } from '../../api';
import { Save, Check, X, AlertTriangle } from 'lucide-react';
import {PatternFormat} from "react-number-format";

function AprovarClientesEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [menuAberto, setMenuAberto] = useState(false);
  const [cliente, setCliente] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [modalAberto, setModalAberto] = useState(false);
  const [erro, setErro] = useState('');
  const [activeTab, setActiveTab] = useState('financeiro'); // Estado para controlar a aba ativa

  useEffect(() => {
    async function fetchCliente() {
      setCarregando(true);
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/clientes-pre-cadastro/${id}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (!response.ok) {
          throw new Error(`Erro ao buscar cliente: ${response.status}`);
        }
        
        const data = await response.json();
        // AQUI O CONSOLE LOG ESTÁ SENDO EXIBIDO 2 VEZES
        console.log('data', data)
        setCliente(data);
        setCarregando(false);
      } catch (error) {
        console.error('Erro ao buscar dados do cliente:', error);
        setErro('Não foi possível carregar os dados do cliente.');
        setCarregando(false);
        
        // Fallback para desenvolvimento caso a API não esteja disponível
        
      }
    }
    fetchCliente();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCliente(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSalvando(true);
    try {
      // Em produção, substituir por chamada real à API
      // const token = localStorage.getItem('token');
      // await fetch(`${API_URL}/clientes-pendentes/${id}`, {
      //   method: 'PUT',
      //   headers: {
      //     'Authorization': `Bearer ${token}`,
      //     'Content-Type': 'application/json'
      //   },
      //   body: JSON.stringify(cliente)
      // });

      // Simulação para desenvolvimento
      await new Promise(resolve => setTimeout(resolve, 800));
      alert('Cliente atualizado com sucesso!');
      setSalvando(false);
    } catch (error) {
      console.error('Erro ao salvar cliente:', error);
      setErro('Não foi possível salvar as alterações.');
      setSalvando(false);
    }
  };

  const handleAprovarCliente = async () => {
    setModalAberto(false);
    setSalvando(true);
    try {
      // Em produção, substituir por chamada real à API
      // const token = localStorage.getItem('token');
      // await fetch(`${API_URL}/clientes-pendentes/${id}/aprovar`, {
      //   method: 'POST',
      //   headers: {
      //     'Authorization': `Bearer ${token}`
      //   }
      // });

      // Simulação para desenvolvimento
      await new Promise(resolve => setTimeout(resolve, 800));
      alert('Cliente aprovado com sucesso!');
      setSalvando(false);
      navigate('/aprovar-clientes');
    } catch (error) {
      console.error('Erro ao aprovar cliente:', error);
      setErro('Não foi possível aprovar o cliente.');
      setSalvando(false);
    }
  };

  if (carregando) {
    return (
      <div className="dashboard-root">
        <Sidebar menuAberto={menuAberto} setMenuAberto={setMenuAberto} />
        <div className="content-container">
          <Topbar
            setMenuAberto={setMenuAberto}
            titulo="Editar Cliente Pendente"
          />
          <div className="conteudo-dashboard">
            <div className="carregando">Carregando dados do cliente...</div>
          </div>
        </div>
      </div>
    );
  }

  if (erro) {
    return (
      <div className="dashboard-root">
        <Sidebar menuAberto={menuAberto} setMenuAberto={setMenuAberto} />
        <div className="main-content">
          <Topbar
            setMenuAberto={setMenuAberto}
            titulo="Editar Cliente Pendente"
          />
          <div className="conteudo-dashboard">
            <div className="erro-container">
              <AlertTriangle size={48} color="#e11d48" />
              <h2>Erro ao carregar dados</h2>
              <p>{erro}</p>
              <button 
                className="btn-voltar" 
                onClick={() => navigate('/aprovar-clientes')}
              >
                Voltar para a lista
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-root">
      <Sidebar menuAberto={menuAberto} setMenuAberto={setMenuAberto} />
      <div className="main-content">
        <Topbar
          setMenuAberto={setMenuAberto}
          titulo="Editar Cliente Pendente"
          
        />
        <div className="conteudo-dashboard">
          <div className="cliente-edit-card">
            <div className="cliente-edit-header">
              <h2>Editar Cliente</h2>
            </div>

            <div className="tabs-navigation">
              <button
                type="button"
                className={`tab-button ${activeTab === 'financeiro' ? 'active' : ''}`}
                onClick={() => setActiveTab('financeiro')}
              >
                Financeiro
              </button>
              <button
                type="button"
                className={`tab-button ${activeTab === 'fiscal' ? 'active' : ''}`}
                onClick={() => setActiveTab('fiscal')}
              >
                Fiscal
              </button>
              <button
                type="button"
                className={`tab-button ${activeTab === 'comercial' ? 'active' : ''}`}
                onClick={() => setActiveTab('comercial')}
              >
                Comercial
              </button>
            </div>

            <form onSubmit={handleSubmit} className="cliente-edit-form">
              {activeTab === 'financeiro' && (
                <div className="tab-content form-grid">
                  <div className="form-group">
                    <label htmlFor="email_cobranca">E-mail Cobrança</label>
                    <input
                      type="email"
                      id="email_cobranca"
                      name="email_cobranca"
                      value={cliente.email_cobranca}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email_xml">E-mail XML</label>
                    <input
                      type="email"
                      id="email_xml"
                      name="email_xml"
                      value={cliente.email_xml}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
              )}
              {activeTab === 'fiscal' && (
                <div className="tab-content form-grid">
                  <div className="form-group">
                    <label htmlFor="cnpj">CNPJ</label>
                    <PatternFormat
                      format="##.###.###/####-##"
                      mask="_"
                      type="text"
                      id="cnpj"
                      name="cnpj"
                      value={cliente.cnpj}
                      onValueChange={(values) => {
                        const { formattedValue } = values;
                        handleChange({ target: { name: "cnpj", value: formattedValue } });
                      }}
                      placeholder="XX.XXX.XXX/XXXX-XX"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="inscricao_estadual">Inscrição Estadual</label>
                    <input
                      type="text"
                      id="inscricao_estadual"
                      name="inscricao_estadual"
                      value={cliente.inscricao_estadual}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              )}
              {activeTab === 'comercial' && (
                <div className="tab-content form-grid">
                  <div className="form-group">
                    <label htmlFor="nome">Razão Social</label>
                    <input
                      type="text"
                      id="razao_social"
                      name="razao_social"
                      value={cliente.razao_social}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="nome">Nome Fantasia</label>
                    <input
                      type="text"
                      id="nome_fantasia"
                      name="nome_fantasia"
                      value={cliente.nome_fantasia}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="telefone_1">Telefone 1</label>
                    <PatternFormat
                      format="(##) ####-####"
                      mask="_"
                      type="text"
                      id="telefone_1"
                      name="telefone_1"
                      value={cliente.telefone_1}
                      onValueChange={(values) => {
                        const { formattedValue, value } = values;
                        const newMask = value.length > 10 ? "(##) #####-####" : "(##) ####-####";
                        handleChange({ target: { name: 'telefone_1', value: formattedValue } });
                      }}
                      placeholder="(XX) XXXXX-XXXX"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="telefone_2">Telefone 2</label>
                    <PatternFormat
                      format="(##) ####-####"
                      mask="_"
                      type="text"
                      id="telefone_2"
                      name="telefone_2"
                      value={cliente.telefone_2}
                      onValueChange={(values) => {
                        const { formattedValue, value } = values;
                        const newMask = value.length > 10 ? "(##) #####-####" : "(##) ####-####";
                        handleChange({ target: { name: 'telefone_2', value: formattedValue } });
                      }}
                      placeholder="(XX) XXXXX-XXXX"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email_1">E-mail 1</label>
                    <input
                      type="email"
                      id="email_1"
                      name="email_1"
                      value={cliente.email_1}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email_2">E-mail 2</label>
                    <input
                      type="email"
                      id="email_2"
                      name="email_2"
                      value={cliente.email_2}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="contato">Nome do Contato</label>
                    <input
                      type="text"
                      id="contato"
                      name="contato"
                      value={cliente.contato}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="logradouro">Logradouro</label>
                    <input
                      type="text"
                      id="logradouro"
                      name="logradouro"
                      value={cliente.logradouro}
                      onChange={handleChange}
                      required
                    />
                  </div>


                  <div className="form-group">
                    <label htmlFor="numero">Número</label>
                    <input
                      type="text"
                      id="numero"
                      name="numero"
                      value={cliente.numero}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="bairro">Bairro</label>
                    <input
                      type="text"
                      id="bairro"
                      name="bairro"
                      value={cliente.bairro}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="cidade">Cidade</label>
                    <input
                      type="text"
                      id="cidade"
                      name="cidade"
                      value={cliente.cidade}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="estado">Estado</label>
                    <select
                      id="estado"
                      name="estado"
                      value={cliente.estado}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Selecione...</option>
                      <option value="AC">Acre</option>
                      <option value="AL">Alagoas</option>
                      <option value="AP">Amapá</option>
                      <option value="AM">Amazonas</option>
                      <option value="BA">Bahia</option>
                      <option value="CE">Ceará</option>
                      <option value="DF">Distrito Federal</option>
                      <option value="ES">Espírito Santo</option>
                      <option value="GO">Goiás</option>
                      <option value="MA">Maranhão</option>
                      <option value="MT">Mato Grosso</option>
                      <option value="MS">Mato Grosso do Sul</option>
                      <option value="MG">Minas Gerais</option>
                      <option value="PA">Pará</option>
                      <option value="PB">Paraíba</option>
                      <option value="PR">Paraná</option>
                      <option value="PE">Pernambuco</option>
                      <option value="PI">Piauí</option>
                      <option value="RJ">Rio de Janeiro</option>
                      <option value="RN">Rio Grande do Norte</option>
                      <option value="RS">Rio Grande do Sul</option>
                      <option value="RO">Rondônia</option>
                      <option value="RR">Roraima</option>
                      <option value="SC">Santa Catarina</option>
                      <option value="SP">São Paulo</option>
                      <option value="SE">Sergipe</option>
                      <option value="TO">Tocantins</option>
                    </select>
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="cep">CEP</label>
                    <PatternFormat
                      format="#####-###"
                      mask="_"
                      type="text"
                      id="cep"
                      name="cep"
                      value={cliente.cep}
                      onValueChange={(values) => {
                        const { formattedValue } = values;
                        handleChange({ target: { name: 'cep', value: formattedValue } });
                      }}
                      placeholder="XXXXX-XXX"
                      required
                    />
                  </div>
                </div>
              )
              }
              
              <div className="form-actions">
                <button 
                  type="button" 
                  className="btn btn-cinza-claro"
                  onClick={() => navigate('/aprovar-cliente/detalhes/' + cliente.id)}
                  disabled={salvando}
                >
                  Cancelar
                </button>
                <button 
                  type="submit" 
                  className="btn btn-primary"
                  disabled={salvando}
                >
                  {salvando ? 'Salvando...' : (
                    <>
                      <Save size={18} style={{ marginRight: 6 }} /> Salvar Alterações
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Modal de Confirmação */}
      {/* {modalAberto && (
        <div className="modal-overlay">
          <div className="modal-confirmar">
            <div className="modal-header">
              <h3>Confirmar Aprovação</h3>
              <button 
                className="modal-fechar" 
                onClick={() => setModalAberto(false)}
                aria-label="Fechar"
              >
                <X size={20} />
              </button>
            </div>
            <div className="modal-body">
              <p>Tem certeza que deseja aprovar o cliente <strong>{cliente.nome}</strong>?</p>
              <p>Esta ação não pode ser desfeita.</p>
            </div>
            <div className="modal-footer">
              <button 
                className="btn-cancelar" 
                onClick={() => setModalAberto(false)}
                disabled={salvando}
              >
                Cancelar
              </button>
              <button 
                className="btn-confirmar btn-primary" 
                onClick={handleAprovarCliente}
                disabled={salvando}
              >
                {salvando ? 'Processando...' : 'Confirmar Aprovação'}
              </button>
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
}

export default AprovarClientesEdit;
